import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.includes.js";
import React from 'react';
import { Box, RED, GREEN, AMBER } from '@applyboard/ui-components';
import { conditional as conditional_icon, eligible, no_intake, ineligible as ineligible_icon } from "../../../../../../assets/images/Results";
import FooterButton from "../../../FooterButton";
import { applyAction } from "../../../../Utilities/ResultsHelper";
import { getDsjResultsRedirectPath, setRegisterURL } from "../../../../Utilities/RedirectTools";
import { getEligibility } from "../../../../Utilities/LanguageHelper";
import { CefEventName } from "../../../../../../EventTracker";
import { studentOnboarding } from "../../../../../controller/consts";
import { useSearchUrl } from "../../../../../../hooks/useSearchUrl";
import { goToSearchPage } from "../../../../../../helpers";
import { useSearchParams } from "../../../../../../hooks";
var useFeatures = function useFeatures(_ref) {
  var programId = _ref.programId,
    result = _ref.result,
    searchData = _ref.searchData,
    isMobile = _ref.isMobile,
    userId = _ref.userId,
    onTrack = _ref.onTrack,
    trackEvent = _ref.trackEvent,
    exploreAction = _ref.exploreAction,
    ineligibleRegisterRedirect = _ref.ineligibleRegisterRedirect;
  var eligibility = result.eligibility,
    intake_available = result.intake_available,
    recruitment_restricted = result.recruitment_restricted;
  var searchUrl = useSearchUrl();
  var searchParams = useSearchParams();
  var clickExploreAction = function clickExploreAction() {
    if (exploreAction) {
      exploreAction();
    } else {
      onTrack(CefEventName.ClickedExploreOtherPrograms);
      goToSearchPage({
        searchParams: searchParams,
        searchUrl: searchUrl
      });
    }
    if (eligibility === 'ineligible') {
      trackEvent({
        event: "".concat(studentOnboarding, " - CEF - Not Eligible: Clicked Explore Other Programs"),
        group: studentOnboarding
      });
    }
  };
  var findAction = function findAction() {
    onTrack(CefEventName.ClickedFindOutWhy);
    if (eligibility === 'ineligible') {
      trackEvent({
        event: "".concat(studentOnboarding, " - CEF - Not Eligible: Clicked Find Out Why"),
        group: studentOnboarding
      });
    }
    var redirectPath = ineligibleRegisterRedirect ? ineligibleRegisterRedirect : getDsjResultsRedirectPath();
    setRegisterURL(redirectPath, searchData);
  };
  var onApplyNow = function onApplyNow() {
    onTrack(CefEventName.ClickedApplyNow);
    applyAction(Number(programId), Number(userId), searchData);
  };
  var color = '';
  var message = '';
  var imgSrc = '';
  var imgAlt = '';
  var buttons = /*#__PURE__*/React.createElement(React.Fragment, null);
  var conditional = false;
  var ineligible = false;
  if (programId === null) {
    color = GREEN[15];
    buttons = /*#__PURE__*/React.createElement(FooterButton, {
      label: "Explore Programs",
      onClick: clickExploreAction
    });
  } else if (eligibility === 'ineligible') {
    color = RED[11];
    message = getEligibility('INELIGIBLE');
    imgSrc = ineligible_icon;
    imgAlt = 'Ineligibility icon with red background and x on top.';
    buttons = /*#__PURE__*/React.createElement(Box, {
      display: "flex",
      flexDirection: isMobile ? 'column' : 'row'
    }, /*#__PURE__*/React.createElement(FooterButton, {
      isBackButton: !userId,
      label: "Explore Other Programs",
      onClick: clickExploreAction
    }), !userId && /*#__PURE__*/React.createElement(FooterButton, {
      label: "Find Out Why",
      onClick: findAction
    }));
    ineligible = true;
  } else if (eligibility === 'eligible' && intake_available && !recruitment_restricted) {
    color = GREEN[15];
    message = getEligibility('ELIGIBLE');
    imgSrc = eligible;
    imgAlt = 'Eligibility icon with green background and 2 checkmarks on top.';
    buttons = /*#__PURE__*/React.createElement(FooterButton, {
      label: "Apply Now",
      onClick: onApplyNow
    });
  } else if (eligibility === 'conditional' && intake_available && !recruitment_restricted) {
    color = GREEN[15];
    message = getEligibility('WITH_CONDITION');
    imgSrc = conditional_icon;
    imgAlt = 'Eligibility icon with green background and 1 checkmark on top.';
    buttons = /*#__PURE__*/React.createElement(FooterButton, {
      label: "Apply Now",
      onClick: onApplyNow
    });
    conditional = true;
  } else if (['eligible', 'conditional'].includes(eligibility)) {
    color = AMBER[17];
    message = getEligibility('NO_INTAKES');
    imgSrc = no_intake;
    imgAlt = 'Eligibility icon with yellow background and a triangle with an exclamation mark on top.';
    buttons = /*#__PURE__*/React.createElement(FooterButton, {
      label: "Explore Other Programs",
      onClick: exploreAction
    });
  }
  return {
    color: color,
    message: message,
    imgSrc: imgSrc,
    imgAlt: imgAlt,
    buttons: buttons,
    conditional: conditional,
    ineligible: ineligible
  };
};
export default useFeatures;